module.exports = __webpack_public_path__ + "img/14.2e247738.jpg";